import {Routes} from "@angular/router";
import {LoginComponent} from "./component/login-component/login.component";
import {
  ForgetPasswordRequestComponent
} from "./component/forget-password-request-options/forget-password-request.component";
import {ForgetPasswordPage} from "./page/forget-password-page/forget-password.page";
import {LoginOtpCodePage} from "./page/login-otp-code-page/login-otp-code-page";
import {LoginWithPasscodeComponent} from "./component/login-with-passcode-component/login-with-passcode.component";
import {LoginWithTokenComponent} from "./component/login-with-token-component/login-with-token.component";


export function CoreSubRoutes() : Routes {

  /**
   *
   * path:
   * Prefix of the module will always be added to the path name
   *
   *      Example
   *      path: "addresses" => route path "ad/addresses" !
   * ------------------------------------------------------------------
   *
   * component:
   * Added components need to be from type "Page"!
   * ------------------------------------------------------------------
   *
   */
  const routes: Routes = [

    {path: '', component: LoginComponent},
    {path: 'login', component: LoginComponent},
    {path: 'forget-password', component: ForgetPasswordPage},
    {path: 'login-otp-code', component: LoginOtpCodePage},
    {path: 'passCodeLogin', component: LoginWithPasscodeComponent},
    {path: 'upload', component: LoginWithTokenComponent},

  ];

  return routes;

}
